import React from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import { Button, Form, Grid } from 'semantic-ui-react';
import { greaterThan0, required } from '../../../lib/FormValidators';
import { dateTimeToDateString } from '../../../lib/FormFormatters';
import { toInt } from '../../../lib/FormNormalizers';
import { Tech3Input } from '../../../components/FormElements';

const ProjectForm = props => {
  return (
    <Form onSubmit={props.handleSubmit} className="formProject">
      <h2 className="dashboard-global__main-title">
        Basic Project Information
        <small> {props.initialValues ? `(${props.initialValues.name})` : ''}</small>
      </h2>
      <Grid columns={1}>
        <Grid.Row>
          <Grid.Column>
            <Field
              columns={3}
              label="Project Name"
              name="name"
              type="text"
              placeholder="Project Name..."
              component={Tech3Input}
              validate={[required]}
              disabled={props.disabledAttributes.name}
            />

            <Field
              label="Project Description"
              name="description"
              type="text"
              placeholder="Project Description..."
              component={Tech3Input}
              validate={[required]}
              disabled={props.disabledAttributes.description}
            />
            <div className="fields-date-container">
              <h5>Project Duration (Pretest included)</h5>
              <Form.Group widths="equal">
                <Field
                  label="Start Date"
                  name="start_date"
                  type="date"
                  max="2050-12-31"
                  component={Tech3Input}
                  format={dateTimeToDateString}
                  validate={[required]}
                  disabled={props.disabledAttributes.start_date}
                />

                <Field
                  label="End Date"
                  name="end_date"
                  type="date"
                  max="2050-12-31"
                  component={Tech3Input}
                  format={dateTimeToDateString}
                  validate={[required]}
                  disabled={props.disabledAttributes.end_date}
                />
              </Form.Group>
            </div>
            <h5>Sessions Information</h5>
            <Field
              label="Number of sessions"
              name="total_participants"
              placeholder="Number of sessions..."
              type="number"
              component={Tech3Input}
              normalize={toInt}
              validate={[required, greaterThan0]}
              disabled={props.disabledAttributes.total_participants}
              max="1000"
            />

            <Button className="green" type="submit" disabled={props.submitting}>
              OK
            </Button>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </Form>
  );
};

const validate = values => {
  const errors = {};
  if (values.end_date < values.start_date) {
    errors.end_date = 'End date must be greater than start date';
  }
  return errors;
};

ProjectForm.propTypes = {
  disabledAttributes: PropTypes.object, // eslint-disable-line react/forbid-prop-types
  handleSubmit: PropTypes.func
};

ProjectForm.defaultProps = {
  handleSubmit: () => {},
  disabledAttributes: {
    name: false,
    description: false,
    start_date: false,
    end_date: false,
    total_participants: false
  }
};

export default reduxForm({
  form: 'project',
  enableReinitialize: true,
  validate
})(ProjectForm);



// WEBPACK FOOTER //
// ./src/scenes/projects/containers/ProjectForm.js